import React from 'react';
import { Link, Icon } from 'basis';
import { config, productGemV2 } from '_config';
import iconOffer from 'images/icons/offers.svg';

const { productName } = config;
const { importantPrivacyNotice, conditionsOfUse, initialDisclosureStatement, interestFreeGuideUrl } = productGemV2.urls;

export const whatHappensNextStepsNzV2 = ratesAndFees => [
  {
    icon: <Icon name="mail" color="indigo" />,
    label: `We've just sent you an email with your important account details. You will receive a welcome pack with your new ${productName} credit card in the mail within 15 business days.`,
  },
  {
    icon: <img src={iconOffer} alt="icon offer" />,
    label: (
      <>
        0% interest for 6 months on general purchases of $250 or more when you select your purchases in the Latitude App
        or Latitude Service Centre within 30 days of the purchase date.{'\u00A0'}
        <Link href={interestFreeGuideUrl} newTab>
          Here's how.
        </Link>
      </>
    ),
  },
  {
    icon: <Icon name="download" color="indigo" />,
    label: (
      <>
        We suggest you save a copy of the
        <Link href={importantPrivacyNotice} newTab>
          {' '}
          Latitude NZ Privacy Notice
        </Link>
        ,{' '}
        <Link href={conditionsOfUse} newTab>
          Conditions of Use
        </Link>
        , and the generic product{' '}
        <Link href={initialDisclosureStatement} newTab>
          Initial Disclosure Statement
        </Link>
        .
      </>
    ),
  },
];
